import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { HighRiskSupplementsCategory } from '@models/highRiskSupplementCategory';
import { handleGetRiskSupplementCategories } from '@store/features/riskSupplementsCategories/actions';
import {
  highRiskSupplementCategoriesErrorSelector,
  highRiskSupplementCategoriesIsLoadingSelector,
  highRiskSupplementCategoriesIsReadySelector,
  highRiskSupplementCategoriesSelector,
} from '@store/features/riskSupplementsCategories/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useRiskSupplementCategories = (): HighRiskSupplementsCategory[] | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(highRiskSupplementCategoriesSelector);
  const isLoading = useSelector(highRiskSupplementCategoriesIsLoadingSelector);
  const isReady = useSelector(highRiskSupplementCategoriesIsReadySelector);
  const error = useSelector(highRiskSupplementCategoriesErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetRiskSupplementCategories());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.highRiskSupplementsCategoriesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useRiskSupplementCategories);
